import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'rmwc/Slider';
import { Text } from '../Text';

export const SliderControl = ({
  value,
  valueFormatter,
  valueOverride,
  valueLabel,
  onChange,
  hideValue,
  minLabel,
  maxLabel,
  spec,
  name,
  ...other
}) => {
  const { min, max, step_size, _default } = spec;

  if (value === null) {
    value = _default;
  }

  const formattedValue = valueFormatter ? valueFormatter(value) : value;

  return (
    <div className="slider">
      {(minLabel || maxLabel) && (
        <div className="slider-label clearfix">
          {minLabel && (
            <Text use="caption" className="slider-min float-left">
              {minLabel}
            </Text>
          )}
          {maxLabel && (
            <Text use="caption" className="slider-max float-right">
              {maxLabel}
            </Text>
          )}
        </div>
      )}
      <div style={{ padding: '0 6px' }}>
        <Slider name={name} min={min} max={max} step={step_size} value={value} onChange={onChange} {...other} />
      </div>
      {!hideValue && (
        <div className="slider-value clearfix" style={{ fontWeight: 500 }}>
          <div className="float-left">{valueLabel}</div>
          <div className="float-right">{valueOverride || formattedValue}</div>
        </div>
      )}
    </div>
  );
};

SliderControl.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step_size: PropTypes.number,
  onChange: PropTypes.func,
};
